$(function(){
  // @-footer-make-new-line-for-mobile
  var target = $('.footer-item__payment-info li:first-child');
  var text = target.text();
  var text2 = text.slice(0, 30);
  var text3 = text.slice(30);
  target.html('<span class="new-line">' + text2 + '</span>' + text3);

  // @r-change-to-loto-from-text
  $('.home .jessica-featured-collection .section-heading__title').each(function(){
        var txt = $(this).html();
        $(this).html(
            txt.replace('Jessica Market','<img class="section-heading__title-logo" src="https://cdn.shopify.com/s/files/1/0693/7621/3297/files/logo_084416b7-a27f-4f07-b611-ed2c7eeabcae.png?v=1673217529">')
        );
    });

  // @r-change-to-icon-from-text

  // Icon - Kakao Talk
  // $('.announcement-bar .social-icons a:first-child .icon svg').replaceWith('<img class="" width="24" height="24" src="https://cdn.shopify.com/s/files/1/0693/7621/3297/files/icon-kakao-talk.png?v=1673594602">');
  // $('.footer-item .social-icons a:first-child .icon svg').replaceWith('<img class="" width="24" height="24" src="https://cdn.shopify.com/s/files/1/0693/7621/3297/files/icon-kakao-talk.png?v=1673594602">');
  // Icon - NAVER CAFE 
  $('.announcement-bar .social-icons a:first-child .icon svg').replaceWith('<img class="" width="24" height="24" src="https://cdn.shopify.com/s/files/1/0693/7621/3297/files/icon-Naver_Cafe.png?v=1673915839">');
  $('.footer-item .social-icons a:first-child .icon svg').replaceWith('<img class="" width="24" height="24" src="https://cdn.shopify.com/s/files/1/0693/7621/3297/files/icon-Naver_Cafe.png?v=1673915839">');

  
});